import store from "../store"
import axios from "axios"
export const cardStyleMixin = {
  data() {
    return {
      hoverOver: false, // wheater the post is being hovered over
    };
  },
  methods: {
    updateText(e) {
      e.preventDefault();
      this.$emit("changePostText", e.target.innerText);
    },
    logText() {
      console.log("Here");
    },
    changeAnonymous() {
      if (this.atCreationPage) {
        this.$emit("changeAnonymous");
      }
    },
    changeBlurPost() {
      if (this.atCreationPage) {
        this.$emit("changeBlurPost");
      }
    },
    sendLikePost() {
      if (this.atCreationPage) {
        this.$emit("changeLikePost");
      } else {
        if (!store.getters.authenticated) {
          store.dispatch("setWarning", "You need to log in to like a post")
          return;
        } else {
          var data = JSON.stringify({
            "postID": this.postID
          });

          var config = {
            method: 'post',
            url: 'http://138.197.71.184:5001/likePost',
            headers: {
              'Content-Type': 'application/json',
            },
            withCredentials: true,
            data: data
          };
          axios(config);
          store.dispatch("like_post", this.postID);
          this.$emit("changeLikePost", store.getters.userData.likedPosts.includes(this.postID))
        }
        return;
      }
    },
    sendDislikePost() {
      if (this.atCreationPage) {
        this.$emit("changeDislikePost");
      } else {
        if (!store.getters.authenticated) {
          store.dispatch("setWarning", "You need to log in to dislike a post")
          return;
        } else {
          var data = JSON.stringify({
            "postID": this.postID
          });

          var config = {
            method: 'post',
            url: 'http://138.197.71.184:5001/dislikePost',
            headers: {
              'Content-Type': 'application/json',
            },
            withCredentials: true,
            data: data
          };
          axios(config);
          store.dispatch("dislike_post", this.postID);
          this.$emit("changeDislikePost", store.getters.userData.dislikedPosts.includes(this.postID))
        }
        return;
      }
    },
    focusOnEdit() {
      this.$emit("focusOnEdit");
    },
  },
  computed: {
    userLikePost() {
      return store.getters.authenticated ? store.getters.userData.likedPosts.includes(this.postID) : false;
    },
    userDislikePost() {
      return store.getters.authenticated ? store.getters.userData.dislikedPosts.includes(this.postID) : false;
    }
  }
}